import { SVGProps } from '../types';

const FileGenericIcon = (props: SVGProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.8 0.45H14.4C14.4727 0.45 14.5425 0.478853 14.5939 0.530273L21.0697 7.00608C21.1211 7.0575 21.15 7.12728 21.15 7.2V21.6C21.15 22.6769 20.2769 23.55 19.2 23.55H4.8C3.72304 23.55 2.85 22.6769 2.85 21.6V2.4C2.85 1.32304 3.72305 0.45 4.8 0.45Z"
      fill="white"
      stroke="#DEDBD4"
      strokeWidth="1.25"
    />
    <path
      d="M14.4 0.3V4.8C14.4 6.12546 15.4745 7.2 16.8 7.2H21.3"
      stroke="#DEDBD4"
      strokeWidth="1.25"
    />
  </svg>
);

export { FileGenericIcon };
